export { default } from './BaseComponent';
